import * as React from "react";
import {
    Box,
    ListItemIcon,
    Menu,
    MenuItem,
    Tooltip,
    Avatar,
    IconButton,
    ListItemText,
} from "@mui/material";
import { Logout, Password } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../providers/UserProvider";
import { authService } from "../../services/Services";

export default function AccountMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const { userDetails, setUserDetails } = React.useContext(UserContext);

    const navigate = useNavigate("");

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = (event) => {
        event.preventDefault();
        authService.logout(userDetails.username);
        setUserDetails();
        navigate("/login");
    };

    const handlePasswordChange = (event) => {
        event.preventDefault();
        navigate("/changePassword");
    };

    return (
        <React.Fragment>
            <Box className="accountMenu">
                <Tooltip title="Account Settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        color="#013c4a"
                    >
                        <Avatar
                            sx={{ width: 32, height: 32, color: "#013c4a" }}
                        />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <MenuItem>
                    <Avatar sx={{ color: "#013c4a" }} /> {userDetails?.username}
                </MenuItem>
                <MenuItem onClick={handlePasswordChange}>
                    <ListItemIcon>
                        <Password fontSize="small" sx={{ color: "#013c4a" }} />
                    </ListItemIcon>
                    <ListItemText primary="Change Password" />
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <Logout fontSize="small" sx={{ color: "#013c4a" }} />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
